

'use strict';
angular.module('pulianiBookStoreApp')
  .controller('AboutUsCtrl', function ($scope,$rootScope) {
$rootScope.title='about us';


});

